import React from 'react';
import { connect } from 'react-redux';
import { useTranslation, Trans } from "react-i18next";

function Refund(props) {
	const { t } = useTranslation();

	return (
		<section className="terms">
			<h1 className="common-title">{t("Refund.title")}</h1>
			<div className="terms-text rf-font-em"><Trans i18nKey="Refund.text"/></div>
			<section>
				<h2 className="terms-title2">{t("Refund.termsItemTitle_1")}</h2>
				<div className="terms-text"><Trans i18nKey="Refund.termsItemText_1" /></div>
				<h2 className="terms-title2">{t("Refund.termsItemInquiriesTitle")}</h2>
				<div className="terms-text">
					<h3>{t("Refund.termsItemInquiriesName")}</h3>
					<p><Trans i18nKey="Refund.termsItemInquiriesText" components={{ l: <a className="local-link" href={t("Refund.termsItemInquiriesLink")} target="_blank">link</a> }}/></p>
				</div>
			</section>
		</section>
	);
}

const mapStateToProps = state => {
	return {
		language: state.piano.language,
	};
  };
  
  export default connect(mapStateToProps)(Refund);
